import {ScorecardRow} from "./row";
import {SandRow} from "../model/participant-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";

export function getSandRow(row: SandRow): ScorecardRow {
    return {
        name: "Sand",
        outValues: row.data.outValues,
        outTotal: row.data.outTotal,
        inValues: arrayOrEmpty(row.data.inValues),
        inTotal: row.data.inTotal,
        total: row.data.total,
        classes: "sand"
    };
}
